import { storage } from "../../consts";
import { cloneDeep } from "lodash";

export const SET_LANG_LIST = "app/global/SET_LANG_LIST";
export const SET_LANG = "app/global/SET_LANG";
export const SET_LANG_FILE = "app/global/SET_LANG_FILE";
export const SET_DEFAULT_LANG_FILE = "app/global/SET_DEFAULT_LANG_FILE";

const initialState = {
  langList: [],
  lang: {},
  defaultLang: {},
  langCode: localStorage.getItem(storage.WEB_CLIENT_LANG) || "en"
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_LANG: {
      const clonedState = cloneDeep(state);
      return { ...clonedState, langCode: action.payload };
    }
    case SET_LANG_LIST: {
      const clonedState = cloneDeep(state);
      return { ...clonedState, langList: action.payload };
    }
    case SET_LANG_FILE: {
      const clonedState = cloneDeep(state);
      return { ...clonedState, lang: action.payload };
    }
    case SET_DEFAULT_LANG_FILE: {
      const clonedState = cloneDeep(state);
      return { ...clonedState, defaultLang: action.payload };
    }
    default: {
      return state;
    }
  }
}

export const setLanguageList = (languages) => ({ type: SET_LANG_LIST, payload: languages });

export const setLanguage = (code) => ({ type: SET_LANG, payload: code });

export const setLanguageFile = (object) => ({ type: SET_LANG_FILE, payload: object });

export const setDefaultLanguageFile = (object) => ({
  type: SET_DEFAULT_LANG_FILE,
  payload: object
});
